<template>
    <v-container
        :fluid="!loading"
        :grid-list-lg="!loading"
        :fill-height="loading"
        :class="loading ? 'container-loading' : ''"
    >
        <v-layout
            wrap
            v-if="!loading"
        >
            <v-flex xs12>
                <v-slide-y-transition mode="out-in">
                    <v-layout
                        row
                        wrap
                        align-center
                        justify-center
                    >
                        <v-flex
                            xs12
                        >
                            <v-card>
                                <v-card-title>
                                    <h3 class="headline">Submit a new lead</h3>
                                </v-card-title>
                                <v-form
                                    ref="form"
                                    lazy-validation
                                    @submit.prevent=""
                                    v-model="formInvalid"
                                >
                                    <v-card-text>
                                        <v-layout
                                            row
                                            wrap
                                        >
<!--                                            <template-->
<!--                                                v-if="showAdditionalInputs"-->
<!--                                            >-->
<!--                                                <v-flex-->
<!--                                                    xs12-->
<!--                                                    md4-->
<!--                                                    v-if="hasRole('intermediary')"-->
<!--                                                >-->
<!--                                                    <v-checkbox-->
<!--                                                        :color="$vuetify.theme.dark ? 'white' : 'primary'"-->
<!--                                                        v-model="create_for_self"-->
<!--                                                        label="Create lead for myself"-->
<!--                                                        @change="unselectIntermediary"-->
<!--                                                    ></v-checkbox>-->
<!--                                                </v-flex>-->
<!--                                                <v-flex-->
<!--                                                    xs12-->
<!--                                                    :md8="hasRole('intermediary')"-->
<!--                                                >-->
<!--                                                    <intermediary-search-->
<!--                                                        ref="intermediarySearch"-->
<!--                                                        v-model="create_for_int"-->
<!--                                                        :disabled="create_for_self"-->
<!--                                                        @update="updateMenuTitleFromSearch"-->
<!--                                                        :error-messages="intermediaryErrors"-->
<!--                                                    ></intermediary-search>-->
<!--                                                </v-flex>-->
<!--                                            </template>-->

                                            <v-flex
                                                xs12
                                                md4
                                            >
                                                <v-text-field
                                                    class="title-branding custom-input"
                                                    v-model="lead.first_name"
                                                    label="First name"
                                                    type="text"
                                                    filled
                                                    :disabled="waiting"
                                                    :error-messages="getErrors('first_name')"
                                                ></v-text-field>
                                            </v-flex>
                                            <!--                                            <v-flex-->
                                            <!--                                                xs12-->
                                            <!--                                                md4-->
                                            <!--                                            >-->
                                            <!--                                                <v-text-field-->
                                            <!--                                                    class="title-branding custom-input"-->
                                            <!--                                                    v-model="lead.middle_name"-->
                                            <!--                                                    label="Middle name"-->
                                            <!--                                                    filled-->
                                            <!--                                                    type="text"-->
                                            <!--                                                    :disabled="waiting"-->
                                            <!--                                                    :error-messages="getErrors('middle_name')"-->
                                            <!--                                                ></v-text-field>-->
                                            <!--                                            </v-flex>-->
                                            <v-flex
                                                xs12
                                                md4
                                            >
                                                <v-text-field
                                                    class="title-branding custom-input"
                                                    v-model="lead.last_name"
                                                    label="Last name"
                                                    type="text"
                                                    filled
                                                    :disabled="waiting"
                                                    :error-messages="getErrors('last_name')"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex
                                                xs12
                                                md4
                                            >
                                                <v-text-field
                                                    class="title-branding custom-input"
                                                    v-model="lead.mobile"
                                                    label="Cellphone"
                                                    type="tel"
                                                    filled
                                                    :disabled="waiting"
                                                    :error-messages="getErrors('mobile')"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex
                                                xs12
                                                md6
                                            >
                                                <v-text-field
                                                    class="title-branding custom-input"
                                                    v-model="lead.email"
                                                    label="Email"
                                                    type="email"
                                                    filled
                                                    :disabled="waiting"
                                                    :error-messages="getErrors('email')"
                                                ></v-text-field>
                                            </v-flex>

                                            <!--                                            <v-flex-->
                                            <!--                                                xs12-->
                                            <!--                                                md4-->
                                            <!--                                            >-->
                                            <!--                                                <v-text-field-->
                                            <!--                                                    class="title-branding custom-input"-->
                                            <!--                                                    v-model="lead.telephone"-->
                                            <!--                                                    label="Telephone"-->
                                            <!--                                                    type="tel"-->
                                            <!--                                                    filled-->
                                            <!--                                                    :disabled="waiting"-->
                                            <!--                                                    :error-messages="getErrors('telephone')"-->
                                            <!--                                                ></v-text-field>-->
                                            <!--                                            </v-flex>-->
                                            <!--                                            <v-flex-->
                                            <!--                                                xs12-->
                                            <!--                                                md3-->
                                            <!--                                            >-->
                                            <!--                                                <v-select-->
                                            <!--                                                    class="title-branding custom-select"-->
                                            <!--                                                    v-model="lead.consult"-->
                                            <!--                                                    :items="consultationOptions"-->
                                            <!--                                                    label="Telephone Consult"-->
                                            <!--                                                    item-text="label"-->
                                            <!--                                                    item-value="id"-->
                                            <!--                                                    filled-->
                                            <!--                                                    :disabled="waiting"-->
                                            <!--                                                    :error-messages="getErrors('consult')"-->
                                            <!--                                                ></v-select>-->
                                            <!--                                            </v-flex>-->
                                            <v-flex
                                                xs12
                                                md6
                                            >
                                                <v-select
                                                    class="title-branding custom-select"
                                                    v-model="lead.lead_type"
                                                    :items="types"
                                                    label="Type of lead"
                                                    item-text="label"
                                                    item-value="id"
                                                    filled
                                                    :disabled="waiting"
                                                    :error-messages="getErrors('lead_type')"
                                                >
                                                    <template v-slot:item="{ item }">
                                                        <v-list-item-content>
                                                            <v-list-item-title>
                                                                {{ item.label }}
                                                            </v-list-item-title>
                                                            <v-list-item-subtitle>
                                                                {{ item.description }}
                                                            </v-list-item-subtitle>
                                                        </v-list-item-content>
                                                    </template>
                                                </v-select>
                                            </v-flex>
                                            <v-flex xs12>
                                                <v-textarea
                                                    class="title-branding custom-input"
                                                    label="Comment"
                                                    v-model="lead.comment"
                                                    auto-grow
                                                    rows="1"
                                                    filled
                                                    :error-messages="getErrors('comment')"
                                                ></v-textarea>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            class="custom-button"
                                            type="button"
                                            :color="$vuetify.theme.dark ? 'primary lighten-1' : 'primary'"
                                            :loading="waiting"
                                            @click="submitLead"
                                            :small="isMobile"
                                        >
                                            Submit
                                        </v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-slide-y-transition>
            </v-flex>
        </v-layout>
        <v-layout
            v-else
            justify-center
            align-center
            column
        >
            <v-progress-circular
                :size="50"
                color="secondary"
                indeterminate
            ></v-progress-circular>
        </v-layout>
    </v-container>
</template>
<script>
    import IntermediarySearch from "./Components/IntermediariesSearch";

    export default {
        components: {
            IntermediarySearch
        },

        data() {
            return {
                types: [],
                loadedLeadTypes: false,

                lead: {},

                waiting: false,

                formInvalid: false,

                consultationOptions: [
                    {
                        id: 0,
                        label: 'No'
                    },
                    {
                        id: 1,
                        label: 'Yes'
                    }
                ],

                errors: [],

                loadedNewLead: false,
                loadedIntermediary: false,

                create_for_self: false,
                create_for_int: null,

                intermediaryErrors: [],
            }
        },


        computed: {
            loading() {
                return !(this.loadedNewLead && this.loadedIntermediary && this.loadedLeadTypes);
            },
            showAdditionalInputs() {
                return (typeof this.$route.params.intermediaryId === 'undefined' || this.$route.params.intermediaryId == null) && this.hasRole('broker-consultant');
            }
        },
        name: 'Leads-Submit',
        mounted() {
            this.resetLead();
            this.getLeadTypes();
            this.setMenuTitle();
        },
        methods: {
            getErrors(key) {
                if (typeof this.errors[key] !== 'undefined') {
                    return this.errors[key];
                }
                return [];
            },

            resetLead() {
                this.lead = {
                    first_name: '',
                    middle_name: '',
                    last_name: '',
                    email: '',
                    mobile: '',
                    telephone: '',
                    consult: 0,
                    lead_type: null,
                    comment: ''
                };

                if (typeof this.$refs.form !== 'undefined') {
                    this.$refs.form.resetValidation();
                }

                this.errors = [];

                this.loadedNewLead = true;
            },
            getLeadTypes() {
                this.$store.dispatch('resources/getResource', 'leadTypes')
                    .then(response => {
                        this.types = response;
                        this.loadedLeadTypes = true;
                    })
                    .catch(error => {
                        console.error(error);
                        this.types = [];
                        this.loadedLeadTypes = true;
                    });
            },
            submitLead() {
                if (!this.$refs.form.validate()) {
                    return false;
                }

                // if (this.showAdditionalInputs && !this.create_for_self && this.create_for_int == null) {
                //     this.intermediaryErrors = ["You need to select an intermediary"];
                //     return false;
                // }

                this.waiting = true;
                this.errors = [];

                let lead = this.lead;

                // if (!this.create_for_self && this.create_for_int !== null) {
                //     lead.intermediary_id = this.create_for_int;
                // } else if (typeof lead.intermediary_id !== 'undefined') {
                //     delete lead.intermediary_id;
                // }


                window.axios.post('/leads/create', {
                    lead: lead
                })
                    .then((response) => {
                        if (typeof response.data.errorMessage !== 'undefined') {
                            this.$toasted.show(response.data.errorMessage, {
                                theme: "error",
                                position: "top-center",
                                duration: 1500
                            });
                        }

                        if (typeof response.data.errors !== 'undefined') {
                            this.errors = response.data.errors;
                        } else {
                            this.$router.push('/my-leads');

                            this.$toasted.show("Lead submitted", {
                                theme: "success",
                                position: "top-center",
                                duration: 1500
                            });

                            this.resetLead();
                        }

                        this.waiting = false;
                    })
                    .catch((error) => {
                        console.error(error);

                        this.$toasted.show("Whoops! Something went wrong!", {
                            theme: "error",
                            position: "top-center",
                            duration: 1500
                        });

                        this.waiting = false;
                    });
            },
            setMenuTitle() {
                if (typeof this.$route.params.intermediaryId !== 'undefined' && this.$route.params.intermediaryId !== null) {
                    window.axios.post('/intermediaries/get', {
                        id: this.$route.params.intermediaryId
                    })
                        .then((response) => {
                            this.updateMenuTitle(response.data.intermediary)

                            this.loadedIntermediary = true;
                        })
                } else {
                    this.loadedIntermediary = true;
                }
            },

            unselectIntermediary() {
                this.create_for_int = null;

                let title = {
                    'type': 'text',
                    'text': 'Submit New Lead',
                    'color': 'white',
                    'slug': 'page-menu-title',
                    'order': 1
                };

                this.intermediaryErrors = [];

                this.$store.dispatch('application/updateTopBarItem', {'item': title, 'position': 'left'});
            },

            updateMenuTitleFromSearch(user) {
                if (typeof user !== 'undefined') {
                    let title = {
                        'type': 'text',
                        'text': 'Submit New Lead - on behalf of ' + user.label,
                        'color': 'white',
                        'slug': 'page-menu-title',
                        'order': 1
                    };

                    this.intermediaryErrors = [];

                    this.$store.dispatch('application/updateTopBarItem', {'item': title, 'position': 'left'});
                } else {
                    this.unselectIntermediary();
                }
            },

            updateMenuTitle(user) {
                let title = {
                    'type': 'text',
                    'text': 'Submit New Lead - on behalf of ' + user.IntMasterCode + ' ' + user.FirstName + ' ' + user.LastName,
                    'color': 'white',
                    'slug': 'page-menu-title',
                    'order': 1
                };

                this.$store.dispatch('application/updateTopBarItem', {'item': title, 'position': 'left'});
            },
        },
    }
</script>
